import React, { Component } from "react";
import AUX from "../../hoc/Aux_";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { searchrdfquery, prediketList } from "../../api/kugi";
import {
  pushCategory,
  pushUnsurAll,
  pushUnsurResultAll,
  pushUnsurResultDic,
  pushSearchText,
  pushObject,
} from "../../actions/general";
import { connect } from "react-redux";
import FormControl from "@material-ui/core/FormControl";
import _ from "lodash";
import { withRouter, Redirect } from "react-router";
import DialogContent from "@material-ui/core/DialogContent";

import { css } from "@emotion/core";
import { BarLoader } from "react-spinners";
import {
  Breadcrumbs,
  Dialog,
  DialogTitle,
  FormHelperText,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
} from "@material-ui/core";
import MyLoader from "../../components/UI/Loader/Loader";
import { Link } from "react-router-dom";
import Axios from "axios";
import PencarianSPO from "./PencarianSPO";
import LoaderPredikat from "../../components/UI/Loader/LoaderPredikat";
import { Link as LinkUI } from "@material-ui/core";

const override = css`
  position: absolute;
  top: 50%;
  left: 40%;
  margin: 0 auto;
`;
let cancelToken;

class PencarianLanjutan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resultQuery: null,
      loading: true,
      loadingDialog: false,
      loadingContent: false,
      loadingPredikat: true,
      keyword: "",
      predikat: "",
      predikatMain: false,
      predikatCategory: [],
      predikatValue: [],
      predikatValueSearch: "",
      predikatTemp: "",
      predikatOption: {
        memiliki: [],
        terdiri: [],
        // kelas: [],
        // nama: [],
        mengacu: [],
        // batas: [],
        bagian: [],
        nonSpesifik: [],
      },
      keywordSearch: false,
      subjectSearch: "",
      predikatSearch: "",
      objekSearch: "",
      chooseKeyword: "subjek",
      // koory: "",
      // koorx: "",
      error: false,
      dialogSubjek: "",
      dialogOpen: false,
      dialogData: [],
      dialogObjekMap: "",
    };
  }

  componentWillMount = async () => {
    await prediketList()
      .then((res) => {
        res.data.map((item) => {
          let placeholder = item.namaprediket.split("#");
          this.setState({
            predikatCategory: [
              ...this.state.predikatCategory,
              item.labelprediket,
            ],
            predikatValue: [...this.state.predikatValue, placeholder[1]],
          });
          if (item.labelprediket.includes("memiliki")) {
            this.state.predikatOption.memiliki.push({
              label: item.labelprediket,
              value: placeholder[1],
            });
          } else if (item.labelprediket.includes("terdiri")) {
            this.state.predikatOption.terdiri.push({
              label: item.labelprediket,
              value: placeholder[1],
            });
          } else if (item.labelprediket.includes("mengacu")) {
            this.state.predikatOption.mengacu.push({
              label: item.labelprediket,
              value: placeholder[1],
            });
            // } else if (item.labelprediket.includes("KELAS")) {
            //   this.state.predikatOption.kelas.push({
            //     label: item.labelprediket,
            //     value: placeholder[1],
            //   });
            // } else if (item.labelprediket.includes("NAMA")) {
            //   this.state.predikatOption.nama.push({
            //     label: item.labelprediket,
            //     value: placeholder[1],
            //   });
            // } else if (item.labelprediket.includes("batas")) {
            //   this.state.predikatOption.batas.push({
            //     label: item.labelprediket,
            //     value: placeholder[1],
            //   });
          } else if (item.labelprediket.includes("bagian")) {
            this.state.predikatOption.bagian.push({
              label: item.labelprediket,
              value: placeholder[1],
            });
          } else {
            this.state.predikatOption.nonSpesifik.push({
              label: item.labelprediket,
              value: placeholder[1],
            });
          }
        });
        this.setState({ loading: false, loadingPredikat: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false, loadingPredikat: false });
      });
    // if (this.props.searchText) {
    //   await this.handleSearchDialog(
    //     this.props.searchText,
    //     this.props.searchText,
    //     "objek"
    //   );
    //   this.props.pushSearchText(null);
    // }
    function compare(a, b) {
      if (a.label.toLowerCase() < b.label.toLowerCase()) {
        return -1;
      }
      if (a.label.toLowerCase() > b.label.toLowerCase()) {
        return 1;
      }
      return 0;
    }
    // console.log(this.state.predikatOption.memiliki.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0)))
    // console.log(this.state.predikatOption.memiliki.sort(compare))
    this.setState({
      predikatOption: {
        memiliki: this.state.predikatOption.memiliki.sort(compare),
        terdiri: this.state.predikatOption.terdiri.sort(compare),
        mengacu: this.state.predikatOption.mengacu.sort(compare),
        nonSpesifik: this.state.predikatOption.nonSpesifik.sort(compare),
      },
    });
    if (this.props.object) {
      console.log(this.props.object);
      if (this.props.object.type === "objek") {
        await this.handleSubObjek(this.props.object.objek);
      } else {
        await this.handleDialog(this.props.object);
      }
      this.props.pushObject(null);
    }
  };

  handleSubmit = (e) => {
    if (this.state.predikat) {
      this.setState({
        keywordSearch: true,
        predikatSearch: this.state.predikat,
        subjectSearch: "",
        objekSearch: "",
        resultQuery: [],
        dialogOpen: false,
        predikatValueSearch: this.state.predikatTemp,
      });
      if (this.state.chooseKeyword === "subjek")
        this.setState({ subjectSearch: this.state.keyword });
      else this.setState({ objekSearch: this.state.keyword });
      this.handleSearch();
    } else {
      this.setState({ error: true });
    }
    // this.setState({ resultQuery:  });
  };

  handleSearch = () => {
    this.setState({
      loading: true,
      loadingContent: true,
      dialogOpen: false,
      resultQuery: [],
      keyword: "",
      predikat: "",
      error: false,
      predikatMain: false,
    });
    if (cancelToken) {
      cancelToken.cancel("Request cancelled");
    }
    cancelToken = Axios.CancelToken.source();
    if (this.state.chooseKeyword === "objek") {
      searchrdfquery(
        this.state.predikat,
        this.state.keyword,
        "",
        cancelToken.token
      )
        .then((res) => {
          console.log(res);
          if (res.data.length !== 0) {
            this.setState({ resultQuery: res.data });
            this.setState({ loading: false, loadingContent: false });
          } else {
            this.setState({ loading: false, loadingContent: false });
          }
        })
        .catch((err) => {
          if (Axios.isCancel(err)) {
            console.log("Request cancelled");
          }
          console.log(err);
          this.setState({ loading: false, loadingContent: false });
        });
    } else {
      searchrdfquery(
        this.state.predikat,
        "",
        this.state.keyword,
        cancelToken.token
      )
        .then(async (res) => {
          if (res.data.length !== 0) {
            let dataTemp = [];
            let idTemp = [];
            // this.setState({ resultQuery: res.data });
            await Promise.all(
              res.data.map((item) => {
                if (idTemp.indexOf(item.objekId) != -1) {
                  dataTemp[idTemp.indexOf(item.objekId)].push(item);
                } else {
                  dataTemp.push([item]);
                  idTemp.push(item.objekId);
                }
              })
            ).then(() => {
              this.setState({ resultQuery: [dataTemp] });
              this.setState({ loading: false, loadingContent: false });
            });
          } else {
            this.setState({ loading: false, loadingContent: false });
          }
        })
        .catch((err) => {
          if (Axios.isCancel(err)) {
            console.log("Request cancelled");
          }
          console.log(err);
          this.setState({ loading: false, loadingContent: false });
        });
    }
  };

  handleSearchDialog = async (item, label, type) => {
    this.setState({
      loading: true,
      loadingContent: true,
      loadingDialog: true,
      dialogOpen: false,
      resultQuery: [],
      dialogData: [],
      keywordSearch: true,
      predikatMain: true,
    });
    if (cancelToken) {
      cancelToken.cancel("Request cancelled");
    }
    cancelToken = Axios.CancelToken.source();
    if (type === "predikat") {
      this.setState({
        predikatSearch: item,
        predikatValueSearch: label,
        keyword: "",
        objekSearch: "",
        subjectSearch: "",
      });
      searchrdfquery(item, "", "", cancelToken.token)
        .then((res) => {
          console.log(res.data);
          this.setState({ resultQuery: res.data });
          this.setState({ loading: false, loadingContent: false });
        })
        .catch((err) => {
          if (Axios.isCancel(err)) {
            console.log("Request cancelled");
          }
          console.log(err);
          this.setState({ loading: false, loadingContent: false });
        });
    } else {
      this.setState({
        // keyword: item,
        subjectSearch: label,
        objekSearch: "",
        predikatSearch: "",
        predikatValueSearch: "",
      });
      const predikatStatis = [
        // "memilikiNAMGAZ",
        "memilikiNAMMAP",
        "memilikiNAMSPE",
        // "memilikiKOORDY",
        // "memilikiKOORDX",
        // "memilikiTIPADM",
        "BerbatasanDengan",
        // "memilikiWADMKK",
        // "memilikiWADMPR",
        // "memilikiKLSTPN",
        // "memilikiNAMLOK",
        // "memilikiARTINAM",
        // "memilikiFOTO1",
        // "memilikiFOTO2",
        // "memilikiFOTO3",
        // "memilikiFOTO4",
      ];
      await Promise.all(
        this.state.predikatValue
        // predikatStatis
        .map(async (predikat) => {
          await searchrdfquery(predikat, "", item, cancelToken.token)
            .then(async (res) => {
              if (res.data.length !== 0) {
                let dataTemp = [];
                let idTemp = [];
                await Promise.all(
                  res.data.map((result) => {
                    let objekData;
                    if (
                      predikat === "memilikiKOORDY" ||
                      predikat === "memilikiKOORDX"
                    ) {
                      objekData = result.objek.split("^", 1);
                      if (predikat === "memilikiKOORDY") {
                        this.setState({ koory: objekData });
                      } else {
                        this.setState({ koorx: objekData });
                      }
                    } else {
                      objekData = result.objek;
                    }
                    if (idTemp.indexOf(result.objekId) != -1) {
                      dataTemp[idTemp.indexOf(result.objekId)].push({
                        subjek: result.subjek,
                        prediket: result.prediket,
                        objek: objekData,
                        objekId: result.objekId,
                      });
                    } else {
                      dataTemp.push([
                        {
                          subjek: result.subjek,
                          prediket: result.prediket,
                          objek: objekData,
                          objekId: result.objekId,
                        },
                      ]);
                      idTemp.push(result.objekId);
                    }
                    // this.setState({
                    //   resultQuery: [
                    //     ...this.state.resultQuery,
                    //     {
                    //       subjek: result.subjek,
                    //       prediket: result.prediket,
                    //       objek: objekData,
                    //       objekId: result.objekId,
                    //     },
                    //   ],
                    //   loading: false,
                    //   loadingContent: false,
                    // });
                  })
                ).then(() => {
                  // this.state.resultQuery.push(dataTemp)
                  this.state.resultQuery.push(dataTemp);
                  this.setState({ loading: false, loadingContent: false });
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.setState({ loading: false, loadingContent: false });
            });
        })
      ).then(() => {
        this.setState({
          loadingDialog: false,
        });
      });
    }
  };

  handleDialog = async (item) => {
    console.log(item);
    const splitRes = item.objekId.split("#");
    console.log(splitRes);
    this.setState({
      dialogSubjek: item.subjek,
      loadingDialog: true,
      resultQuery: null,
      loadingContent: true,
      predikatSearch: "keseluruhan",
      subjectSearch: "",
      dialogOpen: true,
      dialogObjekMap: splitRes[1],
      dialogData: [],
      predikatMain: false,
    });
    const predikatStatis = [
      // "memilikiNAMGAZ",
      // "memilikiNAMMAP",
      // "memilikiNAMSPE",
      // "memilikiKOORDY",
      // "memilikiKOORDX",
      // "memilikiTIPADM",
      "BerbatasanDengan",
      // "memilikiWADMKK",
      // "memilikiWADMPR",
      // "memilikiKLSTPN",
      // "memilikiNAMLOK",
      // "memilikiARTINAM",
      // "memilikiFOTO1",
      // "memilikiFOTO2",
      // "memilikiFOTO3",
      // "memilikiFOTO4",
    ];
    let objekTest;
    if (cancelToken) {
      cancelToken.cancel("Request cancelled");
    }
    cancelToken = Axios.CancelToken.source();
    objekTest = `@${splitRes[1]}`;
    this.setState({ objekSearch: `@${splitRes[1]}` });
    console.log(objekTest);
    await Promise.all(
      this.state.predikatValue
      // predikatStatis
      .map(async (predikat) => {
        console.log(predikat);
        await searchrdfquery(predikat, objekTest, "", cancelToken.token)
          .then(async (res) => {
            if (res.data.length !== 0) {
              this.setState({
                dialogData: [...this.state.dialogData, res.data],
              });
              this.setState({
                loadingContent: false,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              loadingContent: false,
            });
          });
      })
    )
      .then(() => {
        this.setState({
          loadingDialog: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loadingDialog: false,
        });
      });
  };

  handleObjectSearch = async (item, subjek) => {
    this.setState({
      dialogSubjek: subjek,
      loadingDialog: true,
      resultQuery: [],
      loadingContent: true,
      // predikatSearch: "keseluruhan",
      subjectSearch: "",
      dialogOpen: true,
      dialogObjekMap: item,
      dialogData: [],
      predikatMain: false,
    });
    const predikatStatis = [
      // "memilikiNAMGAZ",
      "memilikiNAMMAP",
      "memilikiNAMSPE",
      // "memilikiKOORDY",
      // "memilikiKOORDX",
      // "memilikiTIPADM",
      "BerbatasanDengan",
      // "memilikiWADMKK",
      // "memilikiWADMPR",
      // "memilikiKLSTPN",
      // "memilikiNAMLOK",
      // "memilikiARTINAM",
      // "memilikiFOTO1",
      // "memilikiFOTO2",
      // "memilikiFOTO3",
      // "memilikiFOTO4",
    ];
    if (cancelToken) {
      cancelToken.cancel("Request cancelled");
    }
    cancelToken = Axios.CancelToken.source();
    await Promise.all(
      this.state.predikatValue
      // predikatStatis
      .map(async (predikat) => {
        await searchrdfquery(predikat, `@${item}`, "", cancelToken.token)
          .then(async (res) => {
            if (res.data.length !== 0) {
              this.setState({
                dialogData: [...this.state.dialogData, res.data],
              });
              this.setState({
                loadingContent: false,
              });
            }
          })
          .catch((err) => {});
      })
    )
      .then(() => {
        console.log(this.state.loadingContent);
        this.setState({
          loadingDialog: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loadingDialog: false,
        });
      });
  };

  handlePrediket = (prediket) => {
    let temp = this.state.predikatValue.indexOf(prediket);
    return this.state.predikatCategory[temp];
  };

  handleError = (e) => {
    if (this.state.error) if (!e) return true;
    return false;
  };

  handleId = async (subjek) => {
    if (cancelToken) {
      cancelToken.cancel("Request cancelled");
    }
    cancelToken = Axios.CancelToken.source();
    let objekId = null;
    await searchrdfquery("memilikiFCODE", "", `@${subjek}`, cancelToken.token)
      .then((res) => {
        res.data.map((item) => {
          if (item.objek.length > 2) {
            objekId = item.subjek;
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
    return objekId;
  };

  handleSubObjek = async (subjek) => {
    this.setState({
      resultQuery: [],
      loading: true,
      loadingContent: true,
      keywordSearch: false,
    });
    let item = { objekId: await this.handleId(subjek), subjek: subjek };
    this.setState({ loading: false, loadingContent: false });
    if (item.objekId) {
      this.handleDialog(item);
    } else {
      this.setState({
        keywordSearch: true,
        subjectSearch: subjek,
        resultQuery: [],
        loadingDialog: false,
        predikatSearch: "",
      });
    }
  };

  handleRestateDialog = (subjek) => {
    this.setState({dialogSubjek: subjek, dialogData: [], loadingDialog: true})
  }

  render() {
    const { classes } = this.props;
    return (
      <AUX>
        <div className="sweet-loading" />
        <hr size="30" noshade />
        <section className="sections" style={{ paddingTop: "3%" }}>
          <div className="container">
            <Breadcrumbs aria-label="breadcrumb">
              <LinkUI underline="hover" color="inherit" href="/">
                Home
              </LinkUI>
              <LinkUI
                underline="hover"
                color="text.primary"
                href="/pencarianobjek"
                aria-current="page"
              >
                Pencarian Objek
              </LinkUI>
            </Breadcrumbs>
            <br />
            <b>Pencarian Objek</b>
            <p>
              Pencarian ini berguna untuk mencari berbagai data dengan
              menggunakan parameter - parameter dibawah. Parameter tersebut
              adalah keyword dan predikat. Predikat dapat diisi dengan pilihan
              yang telah disediakan. Cara penggunaan:
              <li>Isi salah satu atau semua parameter yang telah disediakan</li>
              <li>
                Form predikat harus dipilih, jika tidak mengisi keyword maka
                hasil yang akan keluar adalah semua subjek dan objek yang
                memiliki predikat tersebut
              </li>
              <li>
                Jika form keyword diisi, maka pengguna dapat memilih keyword
                tersebut sebagai subjek atau objek dengan memilih pilihan yang
                ada di sebelah form keyword
              </li>
              <li>Tekan tombol Search untuk memulai pencarian</li>
              <li>Akan muncul tampilan loading hingga hasilnya muncul</li>
              <li>Muncul list hasil dibagian bawah</li>
              Contoh: Jika pengguna mengisikan objek dengan kata depok, lalu
              memilih predikat memiliki koordinat bujur, maka akan memunculkan
              data dengan objek yang memiliki kata depok di dalamnya, serta
              mempunyai predikat memiliki koordinat bujur.
            </p>
            <Grid container spacing={3} style={{ paddingLeft: "10px" }}>
              {/* <Grid item xs={4}>
                <TextField
                  autoFocus
                  fullWidth
                  variant="outlined"
                  label="Subjek"
                  onChange={(e) => this.setState({ subjek: e.target.value })}
                />
              </Grid> */}
              <Grid item xs={6}>
                <TextField
                  autoFocus
                  fullWidth
                  variant="outlined"
                  label="Keyword"
                  value={this.state.keyword}
                  onChange={(e) => this.setState({ keyword: e.target.value })}
                />
              </Grid>
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <InputLabel>&emsp;Subjek/Objek</InputLabel>
                  <Select
                    label="subjek/objek"
                    onChange={(e) =>
                      this.setState({ chooseKeyword: e.target.value })
                    }
                    // error={this.handleError(this.state.predikat)}
                    variant="outlined"
                    defaultValue="subjek"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                      style: { maxHeight: 500 },
                      // disableScrollLock: true
                    }}
                  >
                    <MenuItem value={"subjek"}>Subjek</MenuItem>
                    <MenuItem value={"objek"}>Objek</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                {this.state.loadingPredikat ? (
                  <LoaderPredikat />
                ) : (
                  <FormControl fullWidth>
                    <InputLabel>&emsp;Predikat</InputLabel>
                    <Select
                      label="Predikat"
                      onChange={(e) =>
                        this.setState({ predikat: e.target.value })
                      }
                      error={this.handleError(this.state.predikat)}
                      value={this.state.predikat}
                      variant="outlined"
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        getContentAnchorEl: null,
                        style: { maxHeight: 400 },
                        // disableScrollLock: true
                      }}
                    >
                      {/* {this.state.predikatCategory.map((item) => (
                      <MenuItem value={item}>{item}</MenuItem>
                    ))} */}
                      {this.state.predikatOption.nonSpesifik.map((item) => (
                        <MenuItem
                          onClick={() =>
                            this.setState({ predikatTemp: item.label })
                          }
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                      {/* <ListSubheader disableSticky={true}>Kelas</ListSubheader>
                      {this.state.predikatOption.kelas.map((item) => (
                        <MenuItem
                          onClick={() =>
                            this.setState({ predikatTemp: item.label })
                          }
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      ))} */}
                      <ListSubheader disableSticky={true}>
                        Memiliki
                      </ListSubheader>
                      {this.state.predikatOption.memiliki.map((item) => (
                        <MenuItem
                          onClick={() =>
                            this.setState({ predikatTemp: item.label })
                          }
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                      <ListSubheader disableSticky={true}>
                        Mengacu
                      </ListSubheader>
                      {this.state.predikatOption.mengacu.map((item) => (
                        <MenuItem
                          onClick={() =>
                            this.setState({ predikatTemp: item.label })
                          }
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                      {/* <ListSubheader disableSticky={true}>Nama</ListSubheader>
                      {this.state.predikatOption.nama.map((item) => (
                        <MenuItem
                          onClick={() =>
                            this.setState({ predikatTemp: item.label })
                          }
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      ))} */}
                      <ListSubheader disableSticky={true}>
                        Terdiri
                      </ListSubheader>
                      {this.state.predikatOption.terdiri.map((item) => (
                        <MenuItem
                          onClick={() =>
                            this.setState({ predikatTemp: item.label })
                          }
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                      {/* <ListSubheader disableSticky={true}>Batas</ListSubheader>
                      {this.state.predikatOption.batas.map((item) => (
                        <MenuItem
                          onClick={() =>
                            this.setState({ predikatTemp: item.label })
                          }
                          value={item.value}
                        >
                          {item.label}
                        </MenuItem>
                      ))} */}
                    </Select>
                    {this.handleError(this.state.predikat) ? (
                      <FormHelperText>This field is required</FormHelperText>
                    ) : null}
                  </FormControl>
                )}
              </Grid>
              {/* <Grid item xs={4}>
                <TextField
                  autoFocus
                  fullWidth
                  variant="outlined"
                  label="Objek"
                  onChange={(e) => this.setState({ keyword: e.target.value })}
                />
              </Grid> */}
            </Grid>
            {/* <TextField
              autoFocus
              margin="dense"
              fullWidth
              multiline
              rows={8}
              variant="outlined"/> */}
            <Button
              variant="contained"
              style={{
                backgroundColor: this.state.loading ? "#c8ccd1" : "#497ac2",
                color: "#FFF",
                marginTop: "20px",
                outline: "none",
              }}
              disabled={this.state.loading}
              // disabled
              onClick={() => this.handleSubmit()}
            >
              Search
            </Button>
            <br />
            {this.props.object && this.state.loadingPredikat ? (
              <h4 style={{ marginTop: 20 }}>Loading predikat...</h4>
            ) : null}
            {this.state.dialogOpen ? (
              <PencarianSPO
                subjek={this.state.dialogSubjek}
                open={this.state.dialogOpen}
                dataSPO={this.state.dialogData}
                // dialog={this.handleSPO}
                search={this.handleSearchDialog}
                searchObject={this.handleObjectSearch}
                searchSPO={this.handleDialog}
                loading={this.state.loadingDialog}
                objekId={this.state.dialogObjekMap}
                predikatLabel={this.state.predikatCategory}
                predikatValue={this.state.predikatValue}
                restate={this.handleRestateDialog}
              />
            ) : (
              <React.Fragment>
                {this.state.keywordSearch ? (
                  <h6 style={{ marginTop: 20 }}>
                    Pencarian dengan menggunakan{" "}
                    <b>
                      {this.state.subjectSearch
                        ? `Subjek: ${this.state.subjectSearch}`
                        : null}
                    </b>
                    <b>
                      {/* "${this.state.predikatSearch}" */}
                      {this.state.predikatSearch
                        ? `${" "}Predikat: "${this.state.predikatValueSearch}"
                        `
                        : null}
                    </b>
                    <b>
                      {this.state.objekSearch
                        ? `${" "}Objek: ${this.state.objekSearch}`
                        : null}
                    </b>
                    {/* <b>
                      {!this.state.subjectSearch &&
                      !this.state.predikat &&
                      !this.state.objekSearch
                        ? `${" "}semua data`
                        : null}
                    </b> */}
                  </h6>
                ) : null}
                {this.state.loadingContent ? (
                  <MyLoader />
                ) : (
                  <Paper elevation={0} style={{ paddingTop: 10 }}>
                    {this.state.resultQuery === null ? null : (
                      <React.Fragment>
                        {this.state.loading ? null : (
                          <React.Fragment>
                            {this.state.resultQuery.length === 0 &&
                            !this.state.loadingDialog ? (
                              <h6>
                                <b>Hasil tidak ditemukan</b>
                              </h6>
                            ) : (
                              <React.Fragment>
                                {this.state.resultQuery.map((item) => (
                                  <div
                                    className="container"
                                    style={{
                                      paddingTop: 0,
                                      paddingLeft: 0,
                                      paddingRight: 0,
                                    }}
                                  >
                                    {Array.isArray(item) ? (
                                      <React.Fragment>
                                        {this.state.predikatMain ? (
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: 30,
                                            }}
                                          >
                                            <bold>
                                              <h5>
                                                {this.handlePrediket(
                                                  item[0][0].prediket
                                                )}
                                              </h5>
                                            </bold>
                                            <hr />
                                          </div>
                                        ) : null}
                                        {item.map((result) => (
                                          <React.Fragment>
                                            <h6
                                              style={{
                                                marginLeft: this.state
                                                  .predikatMain
                                                  ? 30
                                                  : 0,
                                              }}
                                            >
                                              <a
                                                style={{
                                                  cursor: "pointer",
                                                  color: "blue",
                                                }}
                                                onClick={() =>
                                                  this.handleDialog(result[0])
                                                }
                                              >
                                                {result[0].subjek}
                                              </a>
                                            </h6>
                                            {/* {this.state.predikatMain ? null : ( */}
                                            <div
                                              style={{
                                                marginLeft: this.state
                                                  .predikatMain
                                                  ? 30
                                                  : 0,
                                              }}
                                            >
                                              <b>
                                                {this.handlePrediket(
                                                  result[0].prediket
                                                )}
                                              </b>
                                              <br />
                                            </div>
                                            {/* )} */}
                                            {result.map((res, index) => (
                                              <div
                                                style={{
                                                  marginLeft: this.state
                                                    .predikatMain
                                                    ? 30
                                                    : 0,
                                                }}
                                              >
                                                {res.objek.includes(
                                                  "http://"
                                                ) ? (
                                                  <Link
                                                    to={{
                                                      pathname: res.objek,
                                                    }}
                                                    target="_blank"
                                                  >
                                                    <a>
                                                      {result.length === 1 ? (
                                                        res.objek
                                                      ) : (
                                                        <li>{res.objek}</li>
                                                      )}
                                                    </a>
                                                  </Link>
                                                ) : result.length === 1 ? (
                                                  <a
                                                    style={{
                                                      cursor: "pointer",
                                                      color: "blue",
                                                    }}
                                                    onClick={() =>
                                                      this.handleSubObjek(
                                                        res.objek
                                                      )
                                                    }
                                                  >
                                                    {res.objek}
                                                  </a>
                                                ) : (
                                                  <li
                                                    style={{
                                                      cursor: "pointer",
                                                      color: "blue",
                                                    }}
                                                    onClick={() =>
                                                      this.handleSubObjek(
                                                        res.objek
                                                      )
                                                    }
                                                  >
                                                    {res.objek}
                                                  </li>
                                                )}
                                              </div>
                                            ))}
                                            <p
                                              style={{
                                                marginLeft: this.state
                                                  .predikatMain
                                                  ? 30
                                                  : 0,
                                              }}
                                            >
                                              Objek ID: {result[0].objekId}
                                            </p>
                                            <hr
                                              style={{
                                                marginLeft: this.state
                                                  .predikatMain
                                                  ? 30
                                                  : 0,
                                              }}
                                            />
                                          </React.Fragment>
                                        ))}
                                      </React.Fragment>
                                    ) : (
                                      <React.Fragment>
                                        <h6>
                                          <a
                                            style={{
                                              cursor: "pointer",
                                              color: "blue",
                                            }}
                                            onClick={() =>
                                              this.handleDialog(item)
                                            }
                                          >
                                            {item.subjek}
                                          </a>
                                        </h6>
                                        <b>
                                          {this.handlePrediket(item.prediket)}
                                        </b>
                                        <br />
                                        {item.objek.includes("http://") ? (
                                          <Link
                                            to={{ pathname: item.objek }}
                                            target="_blank"
                                          >
                                            <a>{item.objek}</a>
                                          </Link>
                                        ) : (
                                          <a
                                            style={{
                                              cursor: "pointer",
                                              color: "blue",
                                            }}
                                            onClick={() =>
                                              this.handleSubObjek(item.objek)
                                            }
                                          >
                                            {item.objek}
                                          </a>
                                        )}
                                        <p>Objek ID: {item.objekId}</p>
                                        <hr />
                                      </React.Fragment>
                                    )}
                                  </div>
                                ))}
                                {this.state.loadingDialog ? <MyLoader /> : null}
                              </React.Fragment>
                            )}
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )}
                  </Paper>
                )}
              </React.Fragment>
            )}
            <div className="container">
              <div className="row justify-content-center" id="counter" />
            </div>
          </div>
        </section>
        {/* <hr size="30" noshade /> */}
      </AUX>
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    islight: state.ui_red.islight,
    searchText: state.searchText,
    object: state.object,
  };
};

export default withRouter(
  connect(
    mapStatetoProps,
    {
      pushCategory,
      pushUnsurAll,
      pushUnsurResultDic,
      pushUnsurResultAll,
      pushSearchText,
      pushObject,
    }
  )(PencarianLanjutan)
);
